import { render } from "./TrafficSmallLegend.vue?vue&type=template&id=296cdc1e&scoped=true&ts=true"
import script from "./TrafficSmallLegend.vue?vue&type=script&lang=ts"
export * from "./TrafficSmallLegend.vue?vue&type=script&lang=ts"

import "./TrafficSmallLegend.vue?vue&type=style&index=0&id=296cdc1e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-296cdc1e"]])

export default __exports__